import * as React from "react";
import Component from "../../AbstractComponent";

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import Button from '@material-ui/core/Button';

export class PromptDialog extends Component {
  private prioritizeClosing: boolean = false;
  private title: string = this.trans("title-attention");
  private content: string = this.trans("warning-data-may-be-lost");
  private negativeButtonLabel: string = this.trans("button-discard");
  private relyOnProps: boolean = false;
  private onlyPositiveButton: boolean = false;

  constructor(public props) {
    super(props);
    if (typeof this.props.prioritizeClosing !== "undefined") {
      this.prioritizeClosing = this.props.prioritizeClosing;
    }

    if (typeof this.props.title !== "undefined") {
      this.title = this.props.title;
    }

    if (typeof this.props.content !== "undefined") {
      this.relyOnProps = true;
      this.content = this.props.content;
    }

    if (typeof this.props.negativeButtonLabel !== "undefined") {
      this.negativeButtonLabel = this.props.negativeButtonLabel;
    }

    if (typeof this.props.onlyPositiveButton !== "undefined") {
      this.onlyPositiveButton = this.props.onlyPositiveButton;
    }

    this.close = this.close.bind(this);
    this.discard = this.discard.bind(this);
    this.save = this.save.bind(this);
  }

  public componentWillReceiveProps(nextProps) {
    if (typeof nextProps.title !== "undefined") {
      this.title = nextProps.title;
    }
    if (typeof nextProps.title !== "undefined") {
      this.title = nextProps.title;
    }
    if (typeof nextProps.onlyPositiveButton !== "undefined") {
      this.onlyPositiveButton = nextProps.onlyPositiveButton;
    }
  }

  public discard(): void {
    if (typeof this.props.onDiscard !== "undefined") {
      this.props.onDiscard.call(this);
    }
  }

  public save(): any {
    if (typeof this.props.onSave !== "undefined") {
      this.props.onSave.call(this);
    }
  }

  public close(): void {
    if (typeof this.props.onClose !== "undefined") {
      return this.props.onClose.call(this);
    }

    if (typeof this.props.onDiscard !== "undefined") {
      return this.props.onDiscard.call(this);
    }
  }

  public renderContent(): any {
    if (this.relyOnProps === true) {
      return this.props.content;
    }

    return this.content;
  }

  public render() {
    let actions = [];
    if (this.onlyPositiveButton === false) {
      if (!!this.props.additionalBtns) {
        actions = actions = [
          (
            <Button
              color="primary"
              onClick={this.discard}
            >
              {this.negativeButtonLabel}
            </Button>
          ),
          ...this.props.additionalBtns,
          (
            <Button
              variant="contained"
              color="primary"
              onClick={this.save}
              disabled={this.props.disablePositiveButton}
              style={this.props.positiveButtonStyle ? this.props.positiveButtonStyle : {}}
            >
              {this.props.positiveButtonLabel ? this.props.positiveButtonLabel : this.trans("button-save")}
            </Button>
          )
        ];
      } else {
        actions = actions = [
          (
            <Button
              color="primary"
              onClick={this.discard}
            >
              {this.negativeButtonLabel}
            </Button>
          ),
          (
            <Button
              variant="contained"
              color="primary"
              onClick={this.save}
              disabled={this.props.diableContinueButton || this.props.positiveButtonDisabled || this.props.disablePositiveButton}
              style={this.props.positiveButtonStyle ? this.props.positiveButtonStyle : {}}
            >
              {this.props.positiveButtonLabel ? this.props.positiveButtonLabel : this.trans("button-save")}
            </Button>
          )
        ];
      }
    } else {
      if (!!this.props.additionalBtns) {
        actions = [
          ...this.props.additionalBtns,
          (
            <Button
              variant="contained"
              color="primary"
              onClick={this.save}
              style={this.props.positiveButtonStyle ? this.props.positiveButtonStyle : {}}
              disabled={this.props.disablePositiveButton}
            >
              {this.props.positiveButtonLabel ? this.props.positiveButtonLabel : this.trans("button-save")}
            </Button>
          )
        ];
      } else if(!!this.props.actions) {
        actions = [
          ...this.props.actions
        ]
      } else {
        actions = [
          (
            <Button
              variant="contained"
              color="primary"
              onClick={this.save}
              disabled={this.props.disablePositiveButton}
              style={this.props.positiveButtonStyle ? this.props.positiveButtonStyle : {}}
            >
              {this.props.positiveButtonLabel ? this.props.positiveButtonLabel : this.trans("button-save")}
            </Button>
          )
        ];
      }
    }

    const leavePromptActions =
    [<div style={{display: "flex", justifyContent: "space-between"}}>
      <Button
        color="primary"
        onClick={this.discard}
      >
        {this.trans("button-dont-save")}
      </Button>
      <div>
        <Button
          color="primary"
          onClick={this.close}
        >
          {this.trans("button-cancel")}
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={this.save}
        >
          {this.trans("button-save")}
        </Button>
      </div>
    </div>];
    return (
      <Dialog
        className={`dialog dialog-window has-button-padding ${this.props.innerDialogClasses ? this.props.innerDialogClasses : ""}`}
        open={this.props.openLeavePrompt}
        onClose={this.prioritizeClosing && !this.props.onlyPositiveButton ? this.close :
                  this.props.onlyPositiveButton ? this.save : this.close
                }
        disableBackdropClick={true}
      >
      {
        <DialogTitle className={`${this.props.scrollablePresentation ? "step-header" : ""}`}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              minHeight: "calc(24px + 2em)"
          }} >
            <div>
              <h4 style={{
                  margin: "15px 0 0 0",
                  padding: this.props.subtitle ? "20px 0 0 0" : "20px 0"
                }}
                >
                {this.title}
              </h4>
              {
                this.props.subtitle && (
                <div
                  style={{
                    fontSize: "13px",
                    paddingBottom: "9px",
                    fontWeight: "normal",
                    color: "rgb(137, 137, 137)",
                    margin: 0
                  }}
                  >{this.props.subtitle}</div>
                )
              }
            </div>
          </div>
        </DialogTitle>
      }

        <DialogContent className={`${this.props.scrollablePresentation ? "step-scrollable-content" : ""}`}>
          <div className="dialog-content-wrapper">
            {this.renderContent()}
          </div>
        </DialogContent>
          <div className={`dialog-buttons-wrapper ${this.props.scrollablePresentation ? "step-footer" : ""}`}>
            {
              !this.props.withoutDefaultDilaogButtons &&
              <DialogActions>
                {this.props.leavePrompt ? leavePromptActions : actions}
              </DialogActions>
            }
          </div>
      </Dialog>
    );
  }
}
